import React from 'react';
import { Grid, Row } from "react-bootstrap";
import { Card } from 'components/Card/Card.jsx';
import Cookies from 'universal-cookie';
import cookieManagement from '../utilities/Cookie';
import { FetchAPI } from 'api/fetch';
import { getDomain } from 'client-config';

const cookies = new Cookies();
let logoName = cookies.get('clientSubDomain') == undefined ? cookieManagement.setClientSubDomainToCookie() : cookies.get('clientSubDomain');
let urlhost = window.location.host;
let subDomain = urlhost.split('.')[0];
let currentDomain = getDomain(subDomain)
const Wallet = props => {

    async function qrcodeValue() {
        let URL = `${currentDomain}:3003/scan-qrcode`;
        let res = await FetchAPI(URL);
        console.log("**RESS", res);
    }

    const WalletCards = ({ logoName, walletData }) => {
        return (<Grid fluid>
            <Row>
                <Card style={{ fontSize: '12px' }}
                    title="eSeal"
                    title2="POC"
                    content={
                        <div>
                            <div className="row">
                                <div className="col-md-4 col-md-offset-4">
                                    <Card
                                        stats={"Eseal QR Code with dynamic call to action (SCAN THIS QR WITH YOUR MOBILE PHONE)"}
                                        statsIcon="fa fa-qrcode"
                                        content={
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    fontSize: '45px'
                                                }}
                                            >
                                                <div className="col-md-12 text-center">
                                                    <img width="50%" src="images/qr-code.png" />
                                                </div>
                                            </div>
                                        }
                                    />
                                </div>
                            </div>

                        </div>
                    }
                >
                </Card>
            </Row>
        </Grid>);
    };

    return (
        <div className="content">
            <WalletCards
                logoName={logoName}
                walletData={"walletVal"}
            />
        </div>
    );
}

export default Wallet;
